import { RepositoryFactory } from 'shared/repositories/RepositoryFactory'

const BicycleExemptionRepository = RepositoryFactory.get('bicycle-exemption');

const state = {
  submitted: false,
  steps: [
    {
      id: 1,
      title: 'Gegevens',
      introduction: '<span class="h3">Wie kan een ontheffing van het fietsverbod aanvragen?</span><p>In de AWD geldt een fietsverbod. Voor mensen met een fysieke beperking die niet meer kunnen wandelen is een beperkt aantal ontheffingen van het fietsverbod beschikbaar.<br/><br/>Lees hier ' +
            '<a href="/media/Ontheffing%20fietsverbod_toekenningsvoorwaarden%202025.pdf">alle voorwaarden</a> ' +
            'voor het aanvragen. <br class="hidden-xs"/>Wilt u in aanmerking komen voor een ontheffing, vul dan dit aanvraagformulier in.</p>',
      active: true,
      completed: false,
      $data: null
    },
    {
      id: 2,
      title: 'Foto\'s',
      active: true,
      completed: false,
      $data: null
    },
    {
      id: 3,
      title: 'Controleer',
      active: false,
      completed: false,
      $data: null
    },
    {
      id: 4,
      title: 'Bevestigen',
      text: 'Dank u wel voor uw aanvraag. U ontvangt een e-mail van ons met de gegevens die u heeft ingevuld en geüpload. Daarin staat ook een uitleg over de behandeling van uw aanvraag.',
      completed: false,
      active: false,
      $data: null
    }
  ]
}

const actions = {
  setCurrentStep ({ commit }, step) {
    commit('SET_CURRENT_STEP', step);
  },
  setCompleted ({ commit }, step) {
    commit('SET_COMPLETED', step);
  },
  setSubmitted ({ commit }) {
    commit('SET_SUBMITTED');
  },
  saveForm ({ commit }, $data) {
    commit('SAVE_FORM', $data);
  },
  submit ({ commit }, formData) {
    return new Promise((resolve, reject) => {
      return BicycleExemptionRepository.submit(formData).then(response => {
        resolve(response.data);
      })
    });
  }
}

const mutations = {
  SET_SUBMITTED (state) {
    state.submitted = true;
  },
  SET_CURRENT_STEP (state, currentStep) {
    state.steps.forEach((step, index) => Object.assign(state.steps[index], { active: step.id === currentStep }));
  },
  SET_COMPLETED (state, currentStep) {
    const step = state.steps.find(step => step.id === currentStep)
    Object.assign(step, { completed: true })
  },
  SAVE_FORM (state, $data) {
    const step = state.steps.find((step) => step.active);

    if (!step) return;

    Object.assign(step, { $data });
  }
}

const getters = {
  completedPreviousStep: (state) => (stepId) => {
    if (stepId === 1) return true; // first step always accessible...

    const filtered = state.steps.filter((step) => (step.id < stepId && step.completed))

    return filtered.length === stepId - 1;
  },
  getAllData: state => {
    let data = {};

    state.steps.forEach((step) => {
      data = { ...data, ...step.$data }
    });

    return data;
  },
  getCurrentStep: state => {
    return state.steps.find(step => step.active)
  },
  getSteps: state => state.steps,
  getSubmitted: state => state.submitted
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
